//load modules
import HeroModule from './modules/HeroModule';
import PropertyTileModule from './modules/PropertyTileModule';
import PropertyListingModule from './modules/PropertyListingModule';
import AnimationContentModule from './modules/AnimationContentModule';
import FooterModule from './modules/FooterModule';
import TestimonialModule from './modules/TestimonialModule';
import PropertyCarousel from './modules/PropertyCarousel';
import MapModule from './modules/MapModule';
import AppraisalPopup from './components/AppraisalPopup';

//components
import Navigation from './components/Navigation';
import SideMenu from './components/SideMenu';
import Tab from './components/Tab';

export const components = {
    '.heroModule': HeroModule,
    '.propertyTileModule': PropertyTileModule,
    '.property-listing-module': PropertyListingModule,
    '.animationContentModule': AnimationContentModule,
    'footer': FooterModule,
    '.testimonial-module': TestimonialModule,
    'header.navbar-fixed-top': Navigation,
    '.side-menu': SideMenu,
    '.tabModule': Tab,
    '.property-detail__slideshow': PropertyCarousel,
    '.mapModule': MapModule,
    'body': AppraisalPopup
};


// WEBPACK FOOTER //
// ./javascript/components.js